import { render, staticRenderFns } from "./ChooseOptionGetTeletag.vue?vue&type=template&id=19aae826"
import script from "./ChooseOptionGetTeletag.vue?vue&type=script&lang=js"
export * from "./ChooseOptionGetTeletag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports